import { ChangeDetectorRef, Component, EventEmitter, OnDestroy, OnInit, Output, inject } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { AddressesService } from "src/app/services/addresses.service";
import { CustomerDataService } from "src/app/services/customer-data.service";
import { PhoneBookService } from "src/app/services/phone-book.service";
import { PortingService } from "src/app/services/porting.service";
import { environment } from "src/environments/environment";

@Component({
    selector: "ow-phone-book-form",
    templateUrl: "./phone-book-form.component.html"
})
export class PhoneBookFormComponent implements OnInit, OnDestroy {

    @Output() updateValidity = new EventEmitter<boolean>(false)

    private readonly phoneBookService = inject(PhoneBookService)
    public readonly addressesService = inject(AddressesService)
    public readonly customerDataService = inject(CustomerDataService)
    public readonly portingService = inject(PortingService)
    private readonly changeDetectorRef = inject(ChangeDetectorRef)

    public form = new FormGroup({
        type: new FormControl<"none" | "full" | "short">(this.phoneBookService.getPhoneBookData().type),
        inverse: new FormControl<boolean>(this.phoneBookService.getPhoneBookData().inverse),
        evn: new FormControl<"none" | "full" | "short">(this.phoneBookService.getPhoneBookData().evn),
        evnNote: new FormControl<boolean>(false)
    })
    public showEvnNote = false
    public evnNoteTitle = ""
    public evnNoteText = ""

    private readonly subscriptions = [
        this.form.controls.type.valueChanges.subscribe((value) => {
          if (this.form.controls.type.valid) {
            this.phoneBookService.setPortingData({ type: value! })
          }
          this.updateValidity.emit(this.form.valid)
        }),
        this.form.controls.inverse.valueChanges.subscribe((value) => {
            if (this.form.controls.inverse.valid) {
              this.phoneBookService.setPortingData({ inverse: value! })
            }
            this.updateValidity.emit(this.form.valid)
          }),
          this.form.controls.evn.valueChanges.subscribe((value) => {
            if (this.form.controls.evn.valid) {
              this.phoneBookService.setPortingData({ evn: value! })
            }
            this.updateEvnNote()
            this.form.updateValueAndValidity()
            this.changeDetectorRef.detectChanges()
            this.updateValidity.emit(this.form.valid)
          }),
          this.form.controls.evnNote.valueChanges.subscribe(() => {
            this.form.updateValueAndValidity()
            this.changeDetectorRef.detectChanges()
            this.updateValidity.emit(this.form.valid)
          }),
          this.form.controls.evnNote.statusChanges.subscribe(() => {
            this.form.updateValueAndValidity()
            this.changeDetectorRef.detectChanges()
            this.updateValidity.emit(this.form.valid)
          })
    ]

    ngOnInit(): void {
        this.updateValidity.emit(this.form.valid)
        this.updateEvnNote()
      }
    
    ngOnDestroy(): void {
        this.subscriptions.forEach((subscription) => {
            subscription.unsubscribe()
        })
    }

    private updateEvnNote(): void {
      const evn = this.phoneBookService.getPhoneBookData().evn
      if (evn === "none") {
        this.showEvnNote = false
        this.evnNoteTitle =  ""
        this.evnNoteText = ""
        this.form.controls["evnNote"].setValue(false)
        this.form.controls["evnNote"].clearValidators()
        this.form.controls["evnNote"].setValidators(null)
        this.form.controls["evnNote"].disable()
      } else {
        this.showEvnNote = true
        switch (environment.customerType) {
          case "business":
            this.evnNoteTitle = "Erklärung des Anschlussinhabers gemäß § 11 Abs. 3 TDDDG"
            this.evnNoteText = "Ich erkläre, dass ich alle Mitarbeiter*innen über die Bekanntgabe der Verbindungsdaten informiert habe und künftige Mitarbeiter*innen unverzüglich darüber informieren werde. Sofern ein Betriebsrat oder eine Personalvertretung vorhanden ist, erkläre ich, dass der Betriebsrat/die Personalvertretung beteiligt worden ist, soweit dies gemäß den entsprechenden gesetzlichen Vorschriften erforderlich war."
            break
          case "consumer":
            this.evnNoteTitle = "Erklärung des Anschlussinhabers gemäß § 11 Abs. 1 TDDDG"
            this.evnNoteText = "Ich erkläre, dass ich alle zum Haushalt gehörenden Personen, die den Teilnehmeranschluss nutzen werden, darüber informiert habe und auch künftige Mitnutzer des Teilnehmeranschlusses unverzüglich darüber informieren werde, dass mir die Verbindungsdaten bekannt gegeben werden."
            break
        }
        this.form.controls["evnNote"].clearValidators()
        this.form.controls["evnNote"].setValidators([Validators.requiredTrue])
        this.form.controls["evnNote"].enable()
      }
      this.form.updateValueAndValidity()
      this.changeDetectorRef.detectChanges()
      this.updateValidity.emit(this.form.valid)
    }

}
